<template>
  <div id="hazardous_waste_ship" class="hazardous_waste">
    <div v-if="receivedData">
      <TabsCustomGraphic 
        :received-data="receivedData"
        :data-labels="false"
        id="hazardous"
      />
    </div>
  </div>
</template>
<script>

import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'HazardousWaste',
  components: {
    TabsCustomGraphic: () => import('@/components/graph/TabsCustomGraphic.vue'),
  },

  data () {
    return {
      receivedData: null,
      blockId: 'hazardous_waste',
      cloneElementId: 'hazardous_waste_ship'
    }
  },

  mounted () {
    this.getGraphData()
    Service.elementClone(this.blockId, this.cloneElementId)
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },

  methods: {
    getGraphData() {
      CMS.getGraph(this.userToken, '52, 53').then((response) => {
        this.receivedData = response.data
      })
    }
  }
}
</script>
